import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Label, Loader, Tab } from "semantic-ui-react";
import AddMoney from "./AddMoney/AddMoneyContainer";
import WithDraw from "./WithDraw/WithDrawContainter";

const mapState = state => ({
  auth: state.auth,
  async: state.async,
  payment: state.payment
});

// Balance Text Styles
const balanceStyle = {
  color: "#e3714d",
  fontSize: "20px",
  marginTop: 0
};

// Tab Pan Styles
const panStyle = {
  border: 0,
  boxShadow: "none"
};

// Tab Pans
const panes = [
  {
    menuItem: "Add Money",
    render: () => (
      <Tab.Pane style={panStyle} attached={false}>
        <AddMoney />
      </Tab.Pane>
    )
  },
  {
    menuItem: "Withdraw money to bank",
    render: () => (
      <Tab.Pane style={panStyle} attached={false}>
        <WithDraw />
      </Tab.Pane>
    )
  }
];

class PaymentTab extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    async: PropTypes.object.isRequired,
    payment: PropTypes.object
  };

  render() {
    const { async, payment } = this.props;

    return (
      <React.Fragment>
        <h2 className="totalBalance rupeeIcon" style={balanceStyle}>
          Balance <span>{payment.balance && payment.balance.totalBalance}</span>
          {/* <BalanceInfo payment={payment} iconWidth="15px" /> */}
          <Loader
            active={
              async.loading &&
              !(payment.balance && payment.balance.totalBalance)
            }
            inline
            size="small"
          />
          {!async.loading &&
            !(payment.balance && payment.balance.totalBalance) && (
              <Label basic color="red" size="large">
                Server Error!
              </Label>
            )}
        </h2>

        <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
      </React.Fragment>
    );
  }
}

export default connect(mapState)(PaymentTab);
